const RightArrowIcon = ({
  fill = "white",
  size = 22,
}: {
  fill?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M11.9044 11L8.1895 7.28514C8.07002 7.16566 8.00882 7.01955 8.00589 6.84679C8.00294 6.67404 8.06405 6.52274 8.18922 6.39288C8.31438 6.26302 8.46304 6.19618 8.6352 6.19236C8.80737 6.18854 8.95985 6.25156 9.09264 6.38142L13.1568 10.4456C13.235 10.5267 13.2936 10.6129 13.3327 10.7043C13.3717 10.7957 13.3913 10.8942 13.3913 11C13.3913 11.1058 13.3717 11.2045 13.3325 11.2962C13.2933 11.3878 13.2345 11.4728 13.1561 11.5512L9.09335 15.6135C8.96595 15.7409 8.8147 15.8041 8.6396 15.8032C8.4645 15.8024 8.31438 15.737 8.18922 15.6071C8.06405 15.4773 8.00146 15.3274 8.00146 15.1576C8.00146 14.9878 8.06414 14.8402 8.1895 14.7149L11.9044 11Z"
        fill={fill}
      />
    </svg>
  );
};

export default RightArrowIcon;
